module.exports = __webpack_public_path__ + "assets/img/coin-dimd-bj.e76e8af2.png";